module.exports = "/packs/005-7491427d6626504c63ddefed1fd13be8.jpg";